import { _ as __read } from '../../../tslib.es6-80f01feb.js';
import React__default, { useState, useRef } from 'react';

var isMouseDown = false;
var startX = 0;
var scrollLeft = 0;
var HorizontalScroll = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, children = _a.children, setIsScrollingFalse = _a.setIsScrollingFalse, additionalClassNames = _a.additionalClassNames, onMouseUpAdditionalFunction = _a.onMouseUpAdditionalFunction, onMouseMoveAdditionalFunction = _a.onMouseMoveAdditionalFunction, onMouseDownAdditionalFunction = _a.onMouseDownAdditionalFunction, onMouseLeaveAdditionalFunction = _a.onMouseLeaveAdditionalFunction;
    var _c = __read(useState(), 2), clientX = _c[0], setClientX = _c[1];
    var slider = useRef();
    var handleMouseDown = function (event) {
        isMouseDown = true;
        if (onMouseDownAdditionalFunction) {
            onMouseDownAdditionalFunction();
        }
        startX = event.pageX - slider.current.offsetLeft;
        scrollLeft = slider.current.scrollLeft;
        setClientX(event.clientX);
    };
    var handleMouseLeave = function () {
        isMouseDown = false;
        setIsScrollingFalse();
        if (onMouseLeaveAdditionalFunction) {
            onMouseLeaveAdditionalFunction();
        }
    };
    var handleMouseUp = function (event) {
        isMouseDown = false;
        setIsScrollingFalse();
        if (event.clientX === clientX && onMouseUpAdditionalFunction) {
            onMouseUpAdditionalFunction();
        }
    };
    var handleMouseMove = function (event) {
        if (!isMouseDown) {
            setIsScrollingFalse();
            return;
        }
        if (onMouseMoveAdditionalFunction) {
            onMouseMoveAdditionalFunction();
        }
        event.preventDefault();
        var x = event.pageX - slider.current.offsetLeft;
        var walk = (x - startX) * speed;
        slider.current.scrollLeft = scrollLeft - walk;
    };
    return (React__default.createElement("div", { ref: slider, onMouseUp: handleMouseUp, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave, className: "horizontal-scroll-wr ".concat(additionalClassNames) }, children));
};

export { HorizontalScroll as default };
